// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ybSUDIXHiq8roNqbBq0YB {\n    background-color: #f5f5f5;\n    border-radius: 3px;\n    border: 1px solid #ddd;\n    padding: 0px 6px;\n    margin-left: 4px;\n    margin-right: 4px;\n}\n\n._2Wg-TXSGsdkhqogdq-xuEc {\n    background-color: #f2dede;\n}\n\n._3I414Yb40vKpuytjPp2ZUa {\n    background-color: #fcf8e3;\n}\n\n._13rW_BwPMVADxOYT46U3kX {\n    font-style: italic;\n}\n", ""]);
// Exports
exports.locals = {
	"data": "_3ybSUDIXHiq8roNqbBq0YB",
	"error": "_2Wg-TXSGsdkhqogdq-xuEc _3ybSUDIXHiq8roNqbBq0YB",
	"warning": "_3I414Yb40vKpuytjPp2ZUa _3ybSUDIXHiq8roNqbBq0YB",
	"blank": "_13rW_BwPMVADxOYT46U3kX"
};
module.exports = exports;
